<template>
  <div>
    <div class="button_wrap">
      <el-button type="primary" @click="addProduct">{{
        language("promotionRules.addProduct")
      }}</el-button>
      <el-button type="primary" @click="addBatch">{{
        language("promotionRules.addBatch")
      }}</el-button>
      <!-- <el-button type="danger" @click="deleteBatch">{{
        language("promotionRules.deleteBatch")
      }}</el-button> -->
    </div>
    <div class="page_wrap">
      <page :total="results" @pageChange="pageChange"></page>
    </div>
    <cc-table
      :loadData="false"
      :dataArr="dataArr"
      :config="table2"
      :params="params"
      :refeshParams="refeshTable"
      :emptyText="language('productDetails.emptyText')"
      @selecting-result="selectingResult"
      :showIndex="false"
      :buttonsWidth="90"
     
    ></cc-table>

    <template v-if="dialog">
      <el-dialog
        :close-on-click-modal="false"
        :title="language('promotionRules.addProduct')"
        :visible.sync="dialog"
        width="90%"
        append-to-body
        @close="close"
      >
        <cc-search
          :config="searchConfig"
          @doSearch="doSearch"
          size="medium"
        ></cc-search>

        <el-card shadow="never">
          <el-button type="primary" @click="selectProduct2">{{
            language("promotionRules.addProduct")
          }}</el-button>
        </el-card>
        <cc-table
          :loadData="true"
          :config="table"
          :params="params"
          :refeshParams="refeshTable"
          :emptyText="language('productDetails.emptyText')"
          @selecting-result="selectingResult"
          @submit-select="selectingResult2"
          :showIndex="false"
          ref="table1"
        ></cc-table>
        <!-- :selectObj="true" -->
      </el-dialog>
    </template>

    <!--文件導入-->
    <template v-if="importdialog">
      <el-dialog
        :title="language('shopCampaign.import')"
        :visible.sync="importdialog"
        :close-on-click-modal="false"
        width="50%"
        append-to-body
        @close="close"
      >
        <el-row>
          <el-col>
            <div class="file_box">
              <input type="file" @change="chenge" />
              <el-button>{{ language("shopCampaign.file") }}</el-button>
              {{ target }}
            </div>
          </el-col>
        </el-row>
        <el-row style="margin-top: 10px">
          <el-col>
            <label class="label" style="margin-right: 10px">{{
              language("shopCampaign.downloadTemp")
            }}</label>
            <el-button type="primary" size="mini" @click="downloadTemp">{{
              language("shopCampaign.download")
            }}</el-button>
          </el-col>
        </el-row>
        <span slot="footer">
          <el-button @click="close">{{
            language("shopCampaign.cancel")
          }}</el-button>
          <el-button type="primary" @click="doSubmitBatch()">{{
            language("shopCampaign.confirm")
          }}</el-button>
        </span>
      </el-dialog>
    </template>

    <template v-if="lookDialog">
      <el-dialog
        :title="language('shopCampaign.import')"
        :visible.sync="lookDialog"
        :close-on-click-modal="false"
        width="90%"
        append-to-body
      >
        <cc-table
          :dataArr="lookArr"
          :loadData="false"
          :config="table3"
          :params="params"
          :refeshParams="refeshTable"
          :emptyText="language('productDetails.emptyText')"
          @selecting-result="selectingResult"
          :showIndex="false"
        ></cc-table>
        <div class="num">Results: {{ lookArr.length }} Rows</div>
        <el-button
          type="primary"
          @click="saveImportBatch()"
          class="marign_top"
          >{{ language("shopCampaign.confirm") }}</el-button
        >
      </el-dialog>
    </template>
  </div>
</template>
<script>
import page from "../../../components/page";
import axios from "axios";

export default {
  components: {
    page,
  },
  props: {
    formData: Object,
  },
  data() {
    return {
      selectProductArr: [],
      dialog: false,
      importdialog: false,
      target: "",
      importData: {
        file: "",
      },
      searchConfig: [
        {
          title: "Product Name（Chi.）",
          fieldName: "name",
          style: "text",
          displayName: "",
        },
        {
          title: "SKU ID（Barcode）",
          fieldName: "barcode",
          style: "text",
          displayName: "",
        },
        {
          title: "Model ID",
          fieldName: "mchProductId",
          style: "text",
          displayName: "",
        },
        {
          title: "Brand (Chi)",
          fieldName: "brand",
          style: "text",
          displayName: "",
        },
        // {
        //   title: this.language("scrapProducts.scrapProducts"),
        //   fieldName: "isDiscount",
        //   style: "select",
        //   displayName:"",
        //   options: [
        //     {
        //       label: "是",
        //       value: "1",
        //     },
        //     {
        //       label: "否",
        //       value: "0",
        //     },
        //   ],
        // },
      ],
      params: {},
      refeshTable: -1,
      dataArr: [],
      table: {
        api: "admin/merchant/product/query?auditStatus=1&statuses=1,2&createMb1Product=1&isDiscount=0",
        showPager: true,
        selection: true,
        selectionNoSubmit: true,
        selectingResult: true,
        selectType: "Object",

        indexFixed: "left",
        columns: [
          {
            prop: "saleStatus",
            lable: "Displayed",
            type: "tag",
            minWidth: 110,
            options: {
              1: {
                tagType: "success",
                text: this.language("productDetails.online"),
              },
              0: {
                tagType: "info",
                text: this.language("productDetails.offline"),
              },
              2: {
                tagType: "danger",
                text: this.language("productDetails.invisible"),
              },
              // 1: {
              //   tagType: "danger",
              //   text: "不支持线上销售",
              // },
              // 2: {
              //   tagType: "danger",
              //   text: "待上架",
              // },
            },
          },
          {
            prop: "auditStatus",
            lable: "Status",
            type: "tag",
            minWidth: 120,

            options: {
              0: {
                tagType: "info",
                text: this.language("productDetails.submit"),
              },
              1: {
                tagType: "success",
                text: this.language("productDetails.approved"),
              },
              2: {
                tagType: "danger",
                text: this.language("productDetails.rejected"),
              },
              // hide: {
              //   tagType: "danger",
              //   text: this.language("productDetails.hide"),
              // },
            },
          },
          {
            prop: "type",
            lable: "type",
            minWidth: 190,
            type: "tag",
            options: {
              H: {
                tagType: "success",
                text: "Non Book",
              },
              C: {
                tagType: "success",
                text: "(Book) Mainland/國版",
              },
              D: {
                tagType: "success",
                text: "(Book) HKG/港版",
              },
              E: {
                tagType: "success",
                text: "(Book) TWN/台版",
              },
              F: {
                tagType: "success",
                text: "(Book) Others/外文版",
              },
              A: {
                tagType: "success",
                text: "(Book)SUP/本版",
              },
              'DT000': {
                tagType: "success",
                text: "PRY.HK/小學教參",
              },
              "DT100": {
                tagType: "success",
                text: "SEC.HK/中學教參",
              },
              "DT200": {
                tagType: "success",
                text: "UNI.HK/大專教參",
              },
              'FT000': {
                tagType: "success",
                text: "PRY.F/外文小學教參",
              },
              "FT100": {
                tagType: "success",
                text: "SEC.F/外文中學教參",
              },
              'FT200': {
                tagType: "success",
                text: "UNI.F/外文大專教參",
              },
            },
          },
          {
            prop: "isDiscount",
            lable: this.language("scrapProducts.scrapProducts"),
            minWidth: 100,
            type: "tag",
            options: {
              1: {
                tagType: "success",
                text: "是",
              },
              0: {
                tagType: "info",
                text: "否",
              },
            },
          },
          {
            prop: "mchProductId",
            lable: "Model ID",
            minWidth: 150,
          },
          {
            minWidth: 150,
            prop: "barcode",
            lable: "SKU ID（Barcode）",
          },

          {
            minWidth: 180,
            prop: "name",
            lable: "Product Name（Chi.）",
          },
          {
            minWidth: 120,
            prop: "categories",
            lable: "Category（System）",
          },
          {
            minWidth: 120,
            prop: "brand",
            lable: "Brand",
          },
          {
            prop: "listPrice",
            lable: "OriginalPrice",
            minWidth: 100,

            render: (rows) => {
              return this.$utils.toFixedDigit(rows.listPrice, 2);
            },
          },
          // {
          //   prop: "updateAdminId",
          //   lable: "Update By",
          // },
          // {
          //   prop: "updateTime",
          //   lable: "Last Update",
          // },
          // {
          //   prop: "createTime",
          //   lable: "Create Date",
          // },
        ],
        buttons: [],
      },
      table3: {
        api: "",
        showPager: false,
        columns: [
          {
            prop: "saleStatus",
            lable: "Displayed",
            type: "tag",
            options: {
              1: {
                tagType: "success",
                text: this.language("productDetails.online"),
              },
              0: {
                tagType: "info",
                text: this.language("productDetails.offline"),
              },
              2: {
                tagType: "danger",
                text: this.language("productDetails.invisible"),
              },
              // 1: {
              //   tagType: "danger",
              //   text: "不支持线上销售",
              // },
              // 2: {
              //   tagType: "danger",
              //   text: "待上架",
              // },
            },
          },
          {
            prop: "auditStatus",
            lable: "Status",
            type: "tag",
            options: {
              0: {
                tagType: "info",
                text: this.language("productDetails.submit"),
              },
              1: {
                tagType: "success",
                text: this.language("productDetails.approved"),
              },
              2: {
                tagType: "danger",
                text: this.language("productDetails.rejected"),
              },
              // hide: {
              //   tagType: "danger",
              //   text: this.language("productDetails.hide"),
              // },
            },
          },
          {
            prop: "type",
            lable: "type",
          },
          {
            minWidth: 150,
            prop: "barcode",
            lable: "SKU ID（Barcode）",
          },
          {
            minWidth: 200,
            prop: "name",
            lable: "Product Name（Chi.）",
          },
          {
            minWidth: 200,
            prop: "categories",
            lable: "Category（System）",
          },
          {
            minWidth: 150,
            prop: "brand",
            lable: "Brand",
          },
          {
            prop: "listPrice",
            lable: "OriginalPrice",
            render: (rows) => {
              return this.$utils.toFixedDigit(rows.listPrice, 2);
            },
          },
          // {
          //   prop: "updateAdminId",
          //   lable: "Update By",
          // },
          // {
          //   prop: "updateTime",
          //   lable: "Last Update",
          // },
          // {
          //   prop: "createTime",
          //   lable: "Create Date",
          // },
        ],
        buttons: [],
      },

      table2: {
        api: "admin/merchant/product/query",
        showPager: false,
        // selection: true,
        // selectionNoSubmit: true,
        // selectingResult: true,
        columns: [
          {
            prop: "objData.saleStatus",
            lable: "Displayed",
            type: "tag",
            options: {
              1: {
                tagType: "success",
                text: this.language("productDetails.online"),
              },
              0: {
                tagType: "info",
                text: this.language("productDetails.offline"),
              },
              2: {
                tagType: "danger",
                text: this.language("productDetails.invisible"),
              },
              // 1: {
              //   tagType: "danger",
              //   text: "不支持线上销售",
              // },
              // 2: {
              //   tagType: "danger",
              //   text: "待上架",
              // },
            },
          },

          {
            prop: "objData.barcode",
            lable: "SKU ID（Barcode）",
          },
          {
            prop: "objData.mchProductId",
            lable: "Model ID",
          },
          {
            prop: "objData.name",
            lable: "Product Name（Chi.）",
          },

          {
            prop: "objData.brand",
            lable: "Brand",
          },
        ],
        buttons: [
          {
            name: this.language("promotionRules.delete"),
            click: (row, index) => {
              this.delete(row);
            },
          },
        ],
      },
      results: 0,
      form: {
        pageSize: 10,
        pageNo: 1,
      },
      lookArr: [],
      lookDialog: false,
    };
  },
  methods: {
    addProduct() {
      this.dialog = true;
      this.params = {
        shopNum: this.$shopData.shopNum,
        mchShopNum: this.$shopData.shopNum,
      };
    },
    doSearch(e) {
      this.params = {
        ...e,
        shopNum: this.$shopData.shopNum,
        mchShopNum: this.$shopData.shopNum,
      };
    },
    addBatch() {
      this.importdialog = true;
    },
    pageChange(e) {
      this.form.pageSize = e.pageSize;
      this.form.pageNo = e.pageNo;
      this.getData(this.form);
    },
    getData(e) {
      this.ccRequest
        .do(
          "admin/merchant/marketing/getActivityRuleProduct?activityId=" +
            this.formData.id,
          e
        )
        .then((res) => {
          this.dataArr = res.rows;
          this.results = res.total;
        })
        .catch((err) => {
          this.$message.error(err.response.data.message);
        });
    },
    selectingResult(e) {
      console.log(e)
      // this.selectProductArr = [...e];
    },
    selectingResult2(e){
      console.log(e,222)
      this.selectProductArr = [...e];
    },
    selectProduct2(){
      this.$refs.table1.submitSelected();
      this.selectProduct()
    },
    selectProduct() {
      if (this.selectProductArr.length == 0) {
        this.$message.error("商品為空");
        return false;
      }
      this.saveProduct(this.selectProductArr);
    },
    close() {
      this.target = "";
      this.importData = {};
      this.importdialog = false;
      this.selectProductArr = [];
    },

    saveProduct(arr) {
      let activityRuleList = [];
      for (let i = 0; i < arr.length; i++) {
        activityRuleList.push({
          activityId: this.formData.id,
          extraData: "EQUAL",
          isInclude: 1,
          ruleCode: "target_ids",
          ruleType: "product",
          valueNames: arr[i].name,
          values: arr[i].mb1ProductId,
          shopNum: this.$shopData.shopNum,
          mchShopNum: this.$shopData.shopNum,
          sortOrder: arr[i].sortOrder,
        });
      }
      let data = {
        activityId: this.formData.id,
        activityRuleList: activityRuleList,
        shopNum: this.$shopData.shopNum,
        mchShopNum: this.$shopData.shopNum,
      };
      // console.log(data, arr);
      this.ccRequest
        .do("admin/merchant/marketing/addProductRule", data, "POSTJSON")
        .then((res) => {
          this.dialog = false;
          this.lookDialog = false;
          this.importdialog = false;
          this.selectProductArr = [];
          this.lookArr = [];
          this.target = "";
          this.importData = {};
          this.getData(this.form);
          this.$message({
            type: "success",
            message: this.language("promotionRules.success"),
          });
        })
        .catch((err) => {
          this.$message.error(err.response.data.message);
        });
    },
    chenge(e) {
      if (
        e.target.files[0].name.indexOf(".xlsx") > 0 ||
        e.target.files[0].name.indexOf(".xls") > 0
      ) {
        this.target = e.target.value;
        this.importData.file = e.target.files[0];
      } else {
        this.$message.error(this.language("batchAddCard.xlsxErrorTips"));
        return false;
      }
    },
    downloadTemp() {
      window.open("/admin/merchant/file/downloadFile?code=commodityImport");
      this.$message(this.language("common.downloading"));
    },
    doSubmitBatch() {
      if (!this.importData.file) {
        this.$message.error(this.language("shopCategory.fileUploadTips"));
        return false;
      }
      let formData = new FormData();
      formData.append("objType", "product");
      formData.append("file", this.importData.file);
      formData.append("appId", "supnr");
      formData.append("shopNum", this.$shopData.shopNum);
      formData.append("mchShopNum", this.$shopData.shopNum);
      axios({
        url: "/admin/merchant/marketing/importExcel",
        method: "POST",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
        .then((res) => {
          this.lookArr = res.data;
          this.lookDialog = true;
        })
        .catch((err) => {
          var data = err.response.data;
          this.$message.error(data.message);
        });
    },
    saveImportBatch() {
      if (this.lookArr.length == 0) {
        this.$message.error("商品為空");
        return false;
      }
      this.$confirm(
        this.language("shopCategory.addBatchTips"),
        this.language("common.tips"),
        {
          confirmButtonText: this.language("common.confirm"),
          cancelButtonText: this.language("common.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          this.saveProduct(this.lookArr);
        })
        .catch((err) => {
          console.log(err);
        });
    },

    delete(e) {
      this.$confirm("此操作將刪除商品?", this.language("common.tips"), {
        confirmButtonText: this.language("common.confirm"),
        cancelButtonText: this.language("common.cancel"),
        type: "warning",
      })
        .then(() => {
          this.ccRequest
            .do(
              "admin/merchant/marketing/deleteActivityRule",
              { ruleId: e.id },
              "GET"
            )
            .then((res) => {
              this.getData(this.form);
              this.$message({
                type: "success",
                message: this.language("promotionRules.success"),
              });
            })
            .catch((err) => {
              this.$message.error(err.response.data.message);
            });
        })
        .catch(() => {});
    },
  },
  mounted() {
    this.params = {
      shopNum: this.$shopData.shopNum,
      mchShopNum: this.$shopData.shopNum,
    };
    if (this.formData.id) {
      this.getData({
        pageSize: 10,
        pageNo: 1,
      });
    }
  },
};
</script>
<style scoped>
.button_wrap {
  margin-bottom: 20px;
}
.file_box {
  position: relative;
}
.file_box input {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}
.page_wrap {
  margin-bottom: 20px;
}
.marign_top {
  margin-top: 20px;
}
.num {
  font-size: 18px;
  font-weight: 600;
  margin-top: 10px;
}
</style>